import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-question',
  templateUrl: './icon-question.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconQuestionComponent {}
